<script>
import moment from "moment";
import axios from '@/utils/axios';
import { allUsers } from '@/utils/user';
import "daterangepicker/daterangepicker.js";
import "daterangepicker/daterangepicker.css";
import DateRangePicker from "daterangepicker";
import payment_methods from '@/assets/json/payment-methods';

export default {
  inject: ['setLoading'],
  data() {
    return {
      title: "Finance & Accounts",
      text: "Finance & Accounts",
      data: [],
      users: [],
      customers: [],
      pagination: {
       current_page: 1,
       per_page: 25,
       last_page: 1,
       total: 0,
       links: []
      },
      filter: {
       user: null,
       customer: null,
       search_keyword: '',
       payment_method: null,
       from_date: '',
       to_date: ''
      },
      loading: false,
      payment_methods: payment_methods,
    };
  },

  computed: {
   text1(){
    return `Payments (${this.pagination.total})`;
   }, 
   serialNo(){
    return (this.pagination.current_page - 1) * this.pagination.per_page;
   } 
  },

  mounted(){
   this.getUsers(); 
   this.payments();

   const start = moment().subtract(29, "days");
   const end = moment();

    new DateRangePicker(
      this.$refs.dateRangeInput,
      {
        startDate: start,
        endDate: end,
        locale: {
         format: "DD/MM/YYYY",
         separator: " - "
        },
        ranges: {
          Today: [moment(), moment()],
          Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
          "Last 7 Days": [moment().subtract(6, "days"), moment()],
          "Last 30 Days": [moment().subtract(29, "days"), moment()],
          "This Month": [moment().startOf("month"), moment().endOf("month")],
          "Last Month": [
            moment().subtract(1, "month").startOf("month"),
            moment().subtract(1, "month").endOf("month"),
          ],
        }
      },
      (start, end) => {
        this.setDateRange(start, end);
      },
      this.booking_range
    );
    // Initialize filter date range as soon as picker mounts
    this.setDateRange(start, end);

  }, 

  methods: {

    booking_range(start, end) {
     return start.format("DD/MM/YYYY") + " - " + end.format("DD/MM/YYYY");
    },

    setDateRange(start, end) {
     this.filter.from_date = start.format("YYYY-MM-DD");
     this.filter.to_date = end.format("YYYY-MM-DD");
    },

    async onSearch(search){
     if(!search || search.length < 2) return;
     this.loading = true;
     try{
      const response = await axios.get('/customers/dropdown', { params: { search_keyword: search } });
      this.customers = response.data.data;
     }catch(error){
      this.$swalToast(error.message, 'error');
     }finally{
      this.loading = false;
     }
    },

    async getUsers() {
     try{
      const response = await allUsers();
      this.users = response.data.data;
     }catch(error){
      this.$swalToast(error.message, 'error');
     }
    },

    async payments(page = 1) {
     this.setLoading(true);
     try{
      const params = {
       page,
       per_page: this.pagination.per_page,
       user_id: this.filter.user || '',
       from_date: this.filter.from_date,
       to_date: this.filter.to_date,
       customer_id: this.filter.customer || '',
       payment_method: this.filter.payment_method || '',
       search_keyword: this.filter.search_keyword.trim() || ''
      };
      const query_string = new URLSearchParams(params).toString();
      const response = await axios.get(`/payments?${query_string}`);
      this.data = response.data.data.data;
      this.pagination = {
        current_page: response.data.data.current_page,
        per_page: response.data.data.per_page,
        last_page: response.data.data.last_page,
        total: response.data.data.total,
        links: response.data.data.links
      };
     }catch(error){
      this.$swalToast(error.message, 'error');
     }finally{
      this.setLoading(false);
     }
    },

    changePage(url){
     if (!url) return;
     const page = new URL(url).searchParams.get("page");
     this.payments(page);
    },

   clearFilter(){
    this.filter.user = null;
    this.filter.customer = null;
    this.filter.payment_date = '';
    this.filter.search_keyword = '';
    this.filter.payment_method = null;
    this.payments();
   },

   async exportFile(){
    this.setLoading(true);
    try{
     const response = await axios.get('/users/export/excel', {
      responseType: 'blob'
     });
     const blob = new Blob([response.data], { type: response.headers['content-type'] });
     // Create a link element
     const link = document.createElement('a');
     link.href = URL.createObjectURL(blob);
     // Extract filename from Content-Disposition header if available
     let filename = 'users_export.xlsx';  // fallback default
     const disposition = response.headers['content-disposition'];
     if(disposition && disposition.indexOf('filename=') !== -1){
      const filenameMatch = disposition.match(/filename="?(.+)"?/);
      if (filenameMatch.length === 2) filename = filenameMatch[1];
     }
     link.download = filename;
     // Append to body and trigger click to download
     document.body.appendChild(link);
     link.click();
     // Cleanup
     document.body.removeChild(link);
     URL.revokeObjectURL(link.href);
    }catch(error){
     console.log(error.message);
    }finally{
     this.setLoading(false); 
    }
   }
    
  },
};
</script>

<template>
<layout-header></layout-header>
<layout-sidebar></layout-sidebar>

<!-- Page Wrapper -->
<div class="page-wrapper">
  <div class="content">
    <!-- Breadcrumb -->
    <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
      <breadcrumb :title="title" :text="text" :text1="text1" />
      <div class="d-flex my-xl-auto right-content align-items-center flex-wrap">
        
        <!-- <div class="me-2 mb-2" v-if="pagination.total">
        <div class="dropdown">
        <a href="javascript:void(0);" class="dropdown-toggle btn btn-white d-inline-flex align-items-center" data-bs-toggle="dropdown"><i class="ti ti-file-export me-1"></i>Export
        </a>
        <ul class="dropdown-menu dropdown-menu-end p-3">
        <li><a href="javascript:void(0);" class="dropdown-item rounded-1" @click="exportFile"><i class="ti ti-file-type-xls me-1"></i>Export as Excel</a>
        </li>
        </ul>
        </div>
        </div> -->
        
        <div class="mb-2">
          <!-- <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#admin_modal" class="btn btn-primary d-flex align-items-center" @click="$refs.subadminModal.add();">
            <i class="ti ti-circle-plus me-2"></i>Add Payment
          </a> -->
        </div>
       
      </div>
    </div>
    <!-- /Breadcrumb -->

    <div class="card">
    <div class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
    <!-- <h5>Payments List</h5> -->
    
    <div class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
    
    <div class="me-1" v-if="filter.search_keyword !== '' || filter.customer !== null || filter.user !== null || filter.payment_method !== null ">
     <a href="javascript:void(0);" class="text-danger" @click="clearFilter()"><i class="ti ti-filter-x"></i></a>
    </div>  

    <div class="me-3">
     <div class="input-icon-end position-relative">
      <input type="text" class="form-control date-range bookingrange" ref="dateRangeInput" placeholder="dd/mm/yyyy - dd/mm/yyyy">
      <span class="input-icon-addon"><i class="ti ti-chevron-down"></i></span>
     </div>
    </div>

    <div class="me-3 custom-vueselect">
     <vue-select v-model="filter.customer" :options="customers" :loading="loading" :filterable="false" @search="onSearch" label="name" :reduce="customer => customer.id" placeholder="Customers" @change="payments"/>   
    </div>
    
    <div class="me-3 custom-vueselect">
     <vue-select v-model="filter.user" :options="users" label="name" :reduce="user => user.id" placeholder="Users" @change="payments" />
    </div>

    <div class="me-3 custom-vueselect">
     <vue-select v-model="filter.payment_method" :options="payment_methods" placeholder="Payment Methods" @change="payments" />
    </div>

    <div class="me-3">
    <div class="input-icon-end position-relative">
     <input type="text" class="form-control" v-model="filter.search_keyword" placeholder="Search...."/>
    </div>
    </div>

    <div class="">
     <button type="button" class="btn btn-dark" @click="payments()"><i class="ti ti-search"></i></button>
    </div>

    </div>
    
   </div>

  <div class="card-body card-table-wrapper">
    <div class="custom-datatable-filter table-responsive" v-if="data?.length">
      <table class="card-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Amount</th>
            <th>Method</th>
            <th>Client</th>
            <th>Received By</th>
            <th>Date</th>
            <!-- <th>Actions</th> -->
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in data" :key="row.id">
            <td>{{ serialNo + index + 1 }}.</td>  
            <td><a href="javascript:void(0);" class="fw-bold text-primary" data-bs-toggle="modal" data-bs-target="#payment_detail_modal" @click="$refs.paymentModal.detail(row.id, row.transaction_id, row.notes);">{{ row.amount }}</a></td>
            <td>{{ row.payment_method }}</td>
            <td><a :href="`/crm/customers-details/${row?.customer?.id}`" target="_blank">{{ row?.customer?.name }}</a></td>
            <td>
            <img v-if="row.user?.image" :src="row.user?.image_url" width="22" class="rounded-circle" />
            <i v-else class="ti ti-user-circle fs-18 text-muted"></i>
            {{ row.user?.name }}
          </td>
            <td>{{ $formatDate(row.payment_date, 'DD-MM-YYYY') }}</td>

            <!-- <td>
            <div class="dropdown">
            <button class="btn btn-icon btn-sm rounded-circle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
            <i class="ti ti-dots-vertical"></i>
            </button>
            <ul class="dropdown-menu dropdown-menu-end p-3">
            <li>
            <a class="dropdown-item rounded-1" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#admin_modal" @click="$refs.subadminModal.editAdmin(row)"><i class="ti ti-edit me-1"></i>Edit</a>
            </li>
            </ul>
            </div>  
            </td> -->

          </tr>
        </tbody>
      </table>

      <!-- Pagination -->
    <nav v-if="pagination.links.length > 3" class="mt-2 margin-l-2">
     <ul class="pagination pagination-sm">
      <li v-for="(link, index) in pagination.links" :key="index" :class="['page-item', { active: link.active, disabled: !link.url }]">
        <a class="page-link" href="javascript:void(0)" v-html="link.label" @click="changePage(link.url)"></a>
      </li>
     </ul>
    </nav>

    </div>

    <div v-else class="p-3 text-center text-muted"> No records found.</div>
    
  </div>
</div>
</div>

<app-footer></app-footer>

</div>
<!-- /Page Wrapper -->

<payment-modal ref="paymentModal"></payment-modal>
</template>